import { useEffect, useState } from 'react';
import { THEME_AUTOMATIC } from 'envConfig';
import {
  EffectiveThemeMode,
  getOsPrefersDark,
  normalizeThemePreference,
  resolveEffectiveThemeMode,
  subscribeOsTheme,
} from 'theme/themeMode';

/** Resolve a stored preference (light / dark / automatic) to a concrete MUI mode. */
export const useResolvedThemeMode = (preference?: string | null): EffectiveThemeMode => {
  const pref = normalizeThemePreference(preference);
  const [osDark, setOsDark] = useState(getOsPrefersDark);

  useEffect(() => {
    if (pref !== THEME_AUTOMATIC) return undefined;
    setOsDark(getOsPrefersDark());
    return subscribeOsTheme(setOsDark);
  }, [pref]);

  return resolveEffectiveThemeMode(pref, osDark);
};
